/**
 * @generated SignedSource<<8ba46f4ea088cb87cdf8a2c449e5ab9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeDrawerBrand$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorBrand" | "CreativeTextFormBrand">;
  readonly " $fragmentType": "CreativeDrawerBrand";
};
export type CreativeDrawerBrand$key = {
  readonly " $data"?: CreativeDrawerBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerBrand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeDrawerBrand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeAdvisorBrand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeTextFormBrand"
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "c0fd0be758871c591db8b68fe38fbbc0";

export default node;
